import React from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import * as rState from "../../eventReducer";
import { ErrorList } from "./ErrorList";

interface Props {}

export const ValidationList: React.FC<Props> = () => {
  const {
    missingRequiredDatabaseFields,
    missingRequiredEmailFields,
    missingReservationQuestion,
    hideValidationErrors,
    repeatableValidationErrors,
    dbFieldValidationErrors,
  } = useSelector(rState.getRegistrationValidationData);

  return (
    <div className='w-full divide-y-2 divide-gray-300 h-full overflow-auto scroller'>
      <div>
        <span className='semibold font-sm uppercase text-lg text-brand-dark_blue ml-1'>
          <FormattedMessage
            id='Validation.Group.Errors.Header'
            defaultMessage='Group registration errors'
          />
        </span>
        <ul>
          {missingReservationQuestion ? (
            <li className='text-red-400 text-lg ml-2'>
              <FormattedMessage
                id='Validation.Missing.NumericReservation.Header'
                defaultMessage='Missing numeric reservation question'
              />
            </li>
          ) : null}
        </ul>
      </div>
      <div>
        <span className='semibold font-sm uppercase text-lg text-brand-dark_blue ml-1'>
          <FormattedMessage
            id='Validation.Missing.DatabaseField.Header'
            defaultMessage='Missing required database-fields'
          />
        </span>
        <ul>
          {missingRequiredDatabaseFields.map((missing) => (
            <li key={missing.key} className='text-red-400 text-lg ml-2'>
              {missing.name}
              <ul>
                {missing.additionalMessages.map((additionalMessage, i) => (
                  <li
                    key={`${additionalMessage}_${i}`}
                    className='italic font-thin ml-6'
                  >
                    <FormattedMessage
                      id={additionalMessage}
                      defaultMessage='This rule has additional errors!'
                    />
                  </li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      </div>
      <div>
        <span className='semibold font-sm uppercase text-lg text-brand-dark_blue ml-1'>
          <FormattedMessage
            id='Validation.Missing.Email.Header'
            defaultMessage='Missing required email-fields'
          />
        </span>
        <ul>
          {missingRequiredEmailFields.map((missing) => (
            <li
              key={missing.internalDbValue}
              className='text-red-400 text-lg ml-2'
            >
              {missing.fieldName}
            </li>
          ))}
        </ul>
      </div>
      <ErrorList
        header={"Validation.Hide.Errors.Header"}
        errors={hideValidationErrors}
      />
      <ErrorList
        header={"Validation.Repeatable.Errors.Header"}
        errors={repeatableValidationErrors}
      />
      <ErrorList
        header={"Validation.DatabaseField.Errors.Header"}
        errors={dbFieldValidationErrors}
      />
    </div>
  );
};

export default ValidationList;
